/* Eurton Electric Parts Store: small enhancements. Every page works without this file. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const formatMoney = (cents) => {
    const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    try { return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: fmt }).format(cents / 100); }
    catch (e) { return "$" + (cents / 100).toFixed(2); }
  };

  /* Auto-submit: country selector, filters, sort */
  $$("form[data-autosubmit]").forEach((f) => {
    let t;
    f.addEventListener("change", () => { clearTimeout(t); t = setTimeout(() => f.submit(), 250); });
  });
  const sort = $("[data-sort-form]");
  if (sort) sort.addEventListener("change", () => sort.submit());
  $$("[data-filter-toggle]").forEach((b) => b.addEventListener("click", () => {
    const panel = document.getElementById(b.getAttribute("aria-controls"));
    const open = panel.classList.toggle("open");
    b.setAttribute("aria-expanded", open);
  }));
  /* Quantity steppers */
  $$("[data-qty]").forEach((q) => {
    const input = $("input", q);
    $$("button[data-step]", q).forEach((b) => b.addEventListener("click", () => {
      const step = Number(input.step) || 1, min = input.min === "" ? 0 : Number(input.min);
      const max = input.max ? Number(input.max) : Infinity;
      input.value = Math.min(max, Math.max(min, (Number(input.value) || 0) + Number(b.dataset.step) * step));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }));
  });

  /* Cart page: update totals when a quantity changes */
  const cartForm = document.getElementById("cart-form");
  if (cartForm) {
    let t;
    $$("[data-cart-qty]", cartForm).forEach((i) => i.addEventListener("change", () => {
      clearTimeout(t);
      t = setTimeout(() => { const u = $("[data-update-btn]", cartForm); u ? u.click() : cartForm.submit(); }, 500);
    }));
  }

  /* Carousel buttons */
  $$("[data-track-btns]").forEach((btns) => {
    const track = btns.closest(".section").querySelector("[data-track]");
    if (!track || !track.classList.contains("track")) return;
    const [prev, next] = $$("button", btns);
    const update = () => {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    $$("button", btns).forEach((b) => b.addEventListener("click", () => {
      track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.9, behavior: "smooth" });
    }));
    track.addEventListener("scroll", () => requestAnimationFrame(update), { passive: true });
    addEventListener("resize", update);
    update();
  });

  /* Product page: gallery, variants, add to cart without leaving the page */
  $$("[data-product]").forEach((wrap) => {
    const id = wrap.dataset.product;
    const main = $("[data-main-media]", wrap);
    const thumbs = $$(".thumbs button", wrap);
    const showMedia = (btn) => {
      if (!btn || !main) return;
      main.innerHTML = "";
      const img = new Image();
      img.src = btn.dataset.src; img.alt = btn.dataset.alt || "";
      main.appendChild(img);
      thumbs.forEach((b) => b.setAttribute("aria-current", b === btn ? "true" : "false"));
    };
    thumbs.forEach((b) => b.addEventListener("click", () => showMedia(b)));

    const dataEl = document.querySelector(`[data-variants="${id}"]`);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const select = $("[data-variant-select]", wrap);
    const addBtn = $("[data-add]", wrap), addText = $("[data-add-text]", wrap);
    const strings = window.EurtonStrings || {};
    if (select) select.addEventListener("change", () => {
      const v = variants.find((x) => String(x.id) === select.value);
      if (!v) return;
      $("[data-price]", wrap).textContent = formatMoney(v.price);
      const cmp = $("[data-compare]", wrap);
      if (v.compare_at_price && v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = formatMoney(v.compare_at_price); } else { cmp.hidden = true; }
      $("[data-sku]", wrap).textContent = v.sku || "";
      $("[data-sku-line]", wrap).hidden = !v.sku;
      const stock = $("[data-stock]", wrap);
      stock.classList.toggle("out", !v.available);
      stock.textContent = v.available ? strings.inStock : strings.soldOut;
      addBtn.disabled = !v.available;
      addText.textContent = v.available ? strings.addToCart : strings.soldOut;
      if (v.featured_media) showMedia(thumbs.find((b) => b.dataset.mediaId === String(v.featured_media.id)));
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
    });

    const form = $("[data-product-form]", wrap);
    const msg = $("[data-form-msg]", wrap);
    if (form && window.fetch) form.addEventListener("submit", async (e) => {
      if (e.submitter && e.submitter.name !== "add") return;
      e.preventDefault();
      addBtn.disabled = true; const label = addText.textContent; addText.textContent = strings.adding;
      try {
        const r = await fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || strings.error);
        const cart = await (await fetch(root + "cart.js")).json();
        $$("[data-cart-count]").forEach((c) => { c.textContent = cart.item_count; c.toggleAttribute("data-empty", cart.item_count === 0); });
        msg.className = "form-msg ok"; msg.innerHTML = `${strings.added} <a href="${root}cart">${strings.viewCart}</a>`;
      } catch (err) {
        msg.className = "form-msg err"; msg.textContent = err.message || strings.error;
      }
      msg.hidden = false; addBtn.disabled = false; addText.textContent = label;
    });
  });

  /* Related parts: load from Shopify's recommendations endpoint */
  $$("[data-recs]").forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector("[data-recs]");
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) {}
  });

  /* Login page: show the reset-password panel only when asked */
  const recover = document.getElementById("recover");
  if (recover && !recover.querySelector(".form-msg, .errors") && location.hash !== "#recover") {
    recover.hidden = true;
    $$("[data-toggle-recover]").forEach((a) => a.addEventListener("click", (e) => { e.preventDefault(); recover.hidden = false; $("input", recover).focus(); }));
  }

  /* Address forms: preselect saved country */
  $$("select[data-default]").forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });
})();

/* Floating button: step aside when it would cover the footer, a buy button or the checkout button */
(() => {
  const wrap = document.querySelector("[data-float]");
  if (!wrap || !("IntersectionObserver" in window)) return;
  const targets = document.querySelectorAll(".site-foot .legal, .buy-form button, .buy-form .shopify-payment-button, .summary .btn, .additional-checkout-buttons");
  const hits = new Set();
  let io;
  const watch = () => {
    if (io) io.disconnect();
    const band = Math.max(0, innerHeight - (wrap.offsetHeight || 92));
    io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? hits.add(e.target) : hits.delete(e.target)));
      wrap.classList.toggle("tucked", hits.size > 0);
    }, { rootMargin: `-${band}px 0px 0px 0px` });
    targets.forEach((t) => io.observe(t));
  };
  watch();
  addEventListener("resize", () => { hits.clear(); watch(); });
})();

/* ---------- Old product descriptions (Word / yellow-table era) → new design
   Rebuilds the description in the browser; product data is never changed.
   Headings → small label, tables → spec list, contact footers (old address) removed. */
window.EurtonLegacyDesc = (root) => {
  if (!root || root.dataset.legacyDone) return;
  root.dataset.legacyDone = "1";
  const txt = (el) => (el.textContent || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
  const hasMedia = (el) => el.querySelector && el.querySelector("img, iframe, video, table, a[href^='http']");

  /* 1. Strip Word formatting: inline styles, old attributes, font/span wrappers, Word-only tags */
  root.querySelectorAll("*").forEach((el) => {
    ["style", "class", "align", "valign", "width", "height", "bgcolor", "border", "cellpadding", "cellspacing", "face", "size", "color", "lang"].forEach((a) => el.removeAttribute(a));
    [...el.attributes].forEach((a) => { if (!/^(href|src|alt|title|colspan|rowspan|target|rel|name)$/.test(a.name)) el.removeAttribute(a.name); });
  });
  root.querySelectorAll("xml, style, link, meta, script").forEach((el) => el.remove());
  const unwrap = (el) => { while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el); el.remove(); };
  root.querySelectorAll("font, span, o\\:p, u1\\:p, st1\\:place, st1\\:city, st1\\:state").forEach(unwrap);
  root.querySelectorAll("*").forEach((el) => { if (el.tagName.includes(":")) unwrap(el); });
  root.querySelectorAll("a[name]:not([href])").forEach(unwrap);

  /* Wrap loose text that sits directly in the description into paragraphs, so it can be cleaned like the rest */
  const BLOCK = /^(P|DIV|TABLE|UL|OL|H1|H2|H3|H4|H5|H6|BLOCKQUOTE|DL|HR|IFRAME|FIGURE)$/;
  let run = [];
  const flush = () => { if (run.some((n) => (n.textContent || "").trim())) { const p = document.createElement("p"); run[0].before(p); run.forEach((n) => p.appendChild(n)); } run = []; };
  [...root.childNodes].forEach((n) => { if (n.nodeType === 1 && BLOCK.test(n.tagName)) flush(); else if (n.nodeType === 1 || n.nodeType === 3) run.push(n); });
  flush();

  /* 2. Remove contact footers (phone, email, "Eurton Electric", old Santa Fe Springs address) */
  const CONTACT = /^(eurton electric( co\.?,? inc\.?)?|(phone:?\s*)?\(?800\)?[-.\s]?423[-.\s]?4789.*|((e-?mail|contact):?\s*)?(info|john)@eurtonelectric\.com|9920 painter ave\.?,?|santa fe springs.*|whittier.*90605|phone:?|e-?mail:?|fax:?.*)$/i;
  root.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, b, strong").forEach((el) => {
    if (!root.contains(el) || el.querySelector("table")) return;
    const t = txt(el);
    if (t && CONTACT.test(t)) el.remove();
  });
  /* Contact lines inside one paragraph, separated by line breaks */
  root.querySelectorAll("p, div, td").forEach((el) => {
    if (!root.contains(el) || el.querySelector("p, div, table, h1, h2, h3, h4") || !el.querySelector("br")) return;
    const lines = el.innerHTML.split(/<br\s*\/?>/i);
    const keep = lines.filter((l) => { const t = l.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim(); return !(t && CONTACT.test(t)); });
    if (keep.length !== lines.length) el.innerHTML = keep.join("<br>");
  });
  /* Loose text nodes (e.g. "Santa Fe Springs CA 90670" outside any paragraph) */
  [...root.childNodes].forEach((n) => { if (n.nodeType === 1 && /^(B|STRONG|BR)$/.test(n.tagName) && CONTACT.test(txt(n))) n.remove(); });

  /* 3. Empty blocks and stacked line breaks */
  const prune = () => {
    root.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, b, strong, em, i, u").forEach((el) => {
      if (root.contains(el) && !txt(el) && !hasMedia(el)) el.remove();
    });
  };
  prune();
  root.querySelectorAll("br").forEach((br) => {
    const prev = br.previousSibling, next = br.nextSibling;
    const blankPrev = !prev || (prev.nodeType === 3 && !prev.textContent.trim() && !prev.previousSibling) || (prev.nodeType === 1 && prev.tagName === "BR");
    if (blankPrev || !next || (next.nodeType === 3 && !next.textContent.trim() && !next.nextSibling)) br.remove();
  });
  prune();

  /* 4. Tables → spec lists */
  const cellHtml = (td) => {
    const c = td.cloneNode(true);
    c.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6").forEach((b) => { b.insertAdjacentHTML("afterend", "<br>"); unwrap(b); });
    c.querySelectorAll("b, strong").forEach(unwrap);
    let h = c.innerHTML.replace(/(\s*<br\s*\/?>\s*)+/gi, "<br>").replace(/^(\s|<br>)+|(\s|<br>)+$/gi, "");
    return h;
  };
  const label = (s) => s.replace(/\s*#\s*$/, " #").replace(/\s+/g, " ").trim().toLowerCase().replace(/^\w/, (c) => c.toUpperCase()).replace(/\beurton\b/i, "Eurton").replace(/\bmfd\b/gi, "MFD").replace(/\buf\b/gi, "UF");
  root.querySelectorAll("table").forEach((table) => {
    const rows = [...table.rows].filter((r) => [...r.cells].some((c) => txt(c)));
    if (!rows.length) { table.remove(); return; }
    const pairs = [];
    const cols = Math.max(...rows.map((r) => r.cells.length));
    const looksLikeLabel = (s) => { const L = s.replace(/[^A-Za-z]/g, ""); return s.length < 40 && L.length > 1 && L.replace(/[^A-Z]/g, "").length / L.length >= 0.7; };
    const keyValue = cols === 2 && rows.length >= 2 && rows.every((r) => r.cells.length === 2 && looksLikeLabel(txt(r.cells[0])));
    if (keyValue) {
      rows.forEach((r) => pairs.push([txt(r.cells[0]), cellHtml(r.cells[1])]));
    } else if (rows.length >= 2 && [...rows[0].cells].every((c) => looksLikeLabel(txt(c)) || !txt(c))) {
      const heads = [...rows[0].cells].map((c) => txt(c));
      rows.slice(1).forEach((r) => [...r.cells].forEach((c, i) => pairs.push([heads[i] || "", cellHtml(c)])));
    } else {
      table.classList.add("ld-table");
      table.closest("div")?.classList.add("table-scroll");
      return;
    }
    const dl = document.createElement("dl");
    dl.className = "ld-specs";
    pairs.filter(([, v]) => v.replace(/<br>/g, "").trim()).forEach(([k, v]) => {
      v = v.replace(/&nbsp;/g, " ").replace(/\s+(<br>|$)/g, "$1").trim();
      const row = document.createElement("div");
      const isPart = /part/i.test(k);
      if (isPart) { const [first, ...rest] = v.split("<br>"); v = `<span class="ld-pn">${first}</span>` + (rest.length ? `<span class="ld-sub">${rest.join("<br>")}</span>` : ""); }
      row.innerHTML = `<dt>${label(k)}</dt><dd${isPart ? ' class="ld-part"' : ""}>${v}</dd>`;
      dl.appendChild(row);
    });
    const host = table.parentElement && table.parentElement !== root && table.parentElement.children.length === 1 ? table.parentElement : table;
    host.replaceWith(dl);
  });

  /* "Label: value" lines (e.g. "Thread Size: 15/32") → spec list */
  const KV = /^([A-Za-z][A-Za-z .\/()#&-]{1,28}):\s*(\S.*)$/;
  root.querySelectorAll(":scope > p, :scope > div").forEach((el) => {
    if (el.querySelector("p, div, table, dl")) return;
    const lines = el.innerHTML.split(/<br\s*\/?>/i).map((l) => l.replace(/&nbsp;/g, " ").trim()).filter((l) => l.replace(/<[^>]+>/g, "").trim());
    const kv = lines.map((l) => l.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim().match(KV));
    if (kv.filter(Boolean).length < 2) return;
    const frag = document.createDocumentFragment();
    let dl = null, other = [];
    const flushOther = () => { if (other.length) { const p = document.createElement("p"); p.innerHTML = other.join("<br>"); frag.appendChild(p); other = []; } };
    lines.forEach((l, i) => {
      if (kv[i]) { flushOther(); if (!dl) { dl = document.createElement("dl"); dl.className = "ld-specs"; frag.appendChild(dl); } const row = document.createElement("div"); row.innerHTML = `<dt></dt><dd></dd>`; row.firstChild.textContent = kv[i][1]; row.lastChild.textContent = kv[i][2]; dl.appendChild(row); }
      else { dl = null; other.push(l); }
    });
    flushOther();
    el.replaceWith(frag);
  });

  /* 5. Heading lines before the first spec list → one small label; known phrases → badge / note */
  const blocks = [...root.children];
  const firstSpec = blocks.findIndex((b) => b.matches("dl.ld-specs, table"));
  const heads = [];
  for (const b of blocks.slice(0, firstSpec < 0 ? 3 : firstSpec)) {
    const t = txt(b);
    if (t && t.length <= 40 && t === t.toUpperCase() && /[A-Z]{3}/.test(t) && !b.querySelector("a")) { heads.push(t); b.remove(); }
    else break;
  }
  if (heads.length) root.insertAdjacentHTML("afterbegin", `<p class="ld-kicker">${heads.join(" ").replace(/\s+/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}</p>`);
  root.querySelectorAll("p, div").forEach((el) => {
    if (!root.contains(el)) return;
    const t = txt(el);
    if (/^quantity discounts? available\.?$/i.test(t)) el.outerHTML = '<p class="ld-badge">Quantity discounts available</p>';
    else if (/^all brushes priced individually/i.test(t)) el.outerHTML = '<p class="ld-note">All brushes are priced individually, not as sets.</p>';
    else if (/^eurton electric sells/i.test(t)) { el.className = "ld-lead"; el.innerHTML = el.innerHTML.replace(/(<br\s*\/?>|&nbsp;|\s)+$/i, "").replace(/(\S)$/, (m, c) => (/[.!]/.test(c) ? m : m + ".")); }
  });
  /* An intro paragraph and the badge read better side by side */
  const lead = root.querySelector(".ld-lead"), badge = root.querySelector(".ld-badge");
  if (lead && badge && lead.nextElementSibling === badge) { const w = document.createElement("div"); w.className = "ld-intro"; lead.before(w); w.append(lead, badge); }
  /* Lists of short all-caps h4 lines (capacitor features) → bullet list */
  const h4s = [...root.querySelectorAll(":scope > h4, :scope > h1, :scope > h5")].filter((h) => txt(h).length < 60);
  if (h4s.length >= 3) {
    const ul = document.createElement("ul"); ul.className = "ld-features";
    h4s[0].before(ul);
    h4s.forEach((h) => { const li = document.createElement("li"); li.textContent = txt(h); ul.appendChild(li); h.remove(); });
  }
  root.classList.add("ld");
};
document.querySelectorAll("[data-legacy-desc]").forEach((el) => window.EurtonLegacyDesc(el));
